/* Полоса над содержимым раздела. Цвет — по серьёзности: устаревший срез —
   предупреждение, неудачная загрузка или недоступная папка — ошибка. */
.banner {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  gap: 16px;
  padding: 10px 20px 10px 24px;
  border-bottom: 1px solid var(--border);
  box-shadow: inset 4px 0 0 var(--tone);
}

.warn { --tone: var(--warn); background: var(--warn-bg); }
.error { --tone: var(--err); background: var(--err-bg); }

.text { flex: 1; min-width: 0; }

.title { font-size: 14px; font-weight: 600; color: var(--text); }

.detail {
  margin-top: 2px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text2);
  overflow-wrap: anywhere;
}

.actions { display: flex; flex-shrink: 0; align-items: center; gap: 8px; }

.link {
  padding: 5px 10px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  text-decoration: none;
  white-space: nowrap;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.link:hover { border-color: var(--slate-lt); }

.close {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  color: var(--text2);
  background: none;
  border: none;
  border-radius: var(--r-sm);
  cursor: pointer;
}

.close:hover { color: var(--text); background: var(--table-hover); }

@media (max-width: 699px) {
  .banner { flex-direction: column; gap: 8px; padding: 10px 16px 10px 20px; }
  .actions { align-self: stretch; justify-content: space-between; }
}
